// Create the component factory
mod.components = mod.factory.create(mod.baseModule);

// ----------------------------------------------------------------------------
// Base
// ----------------------------------------------------------------------------

mod.components.define("Base", function(fn) {

	// Default values
	fn.prototype.valueNone = "-32768";
	fn.prototype.valueAll = "%";

	// Perform the selected action on the target
	// e.g., "show", "industry_val_select"
	fn.prototype.handleAction = function(type, targetId) {
		type = type.toLowerCase();
		var $target = $("#" + targetId);

		if (type == "show") {
			$target.show();
		}
		else if (type == "hide") {
			$target.hide();
		}
		else if (type == "reload") {
			var value = this.getValue();
			var targetType = $target.attr("data-initfn");
			var targetClass = $target.data("controller");

			this.getAsync(targetType, value, targetClass);
		}
	};

	fn.prototype.getAsync = function(componentType, safeName, receivingClass) {
		if (receivingClass && receivingClass.receiveAsync) {
			$.ajax({
				url: ("~/Screener/GetComponentAsync").resolveUrl(),
				dataType: "json",
				data: {
					componentType: componentType,
					safeName: safeName
				},
				cache: false,
				context: this,
				success: function(response) {
					if (response) {
						receivingClass.receiveAsync(response);
					}
				},
				error: this.receiveAsyncError,
				beforeSend: function() {
					this.showLoading();
				},
				complete: function() {
					this.hideLoading();
					mod.observer.trigger("screener - screen", { resetPaging: true });
				}
			});
		}
	};

	fn.prototype.showLoading = function() {
		this.$el.addClass("loading");
	};

	fn.prototype.hideLoading = function() {
		this.$el.removeClass("loading");
	};

	fn.prototype.receiveAsync = function(response) { };

	fn.prototype.receiveAsyncError = function(response) {
		alert("Component failed to load.");
	};

	// Interpret the actions json and run each action
	fn.prototype.parseActions = function(actions) {
		for (var action in actions) {
			for (var i = 0; i < actions[action].length; i++) {
				this.handleAction(action, actions[action][i]);
			}
		}
	};

	fn.prototype.getValue = function() { };

	fn.prototype.setValue = function(value) { };

	fn.prototype.getIdentifier = function() { };

	fn.prototype.getClause = function(operator, value) {
		return {
			operator: operator,
			value: value
		};
	};

	fn.prototype.format = function(type, value) {
		var output = this.cleanValue(value);

		if (type === 'magnitude1000000') {
			output *= 1000000;
			type = 'magnitudemil';
		}

		if (type === 'percent100') {
			output *= 100;
		}
		else if (type === 'magnitudemil') {
			output /= 1000000;
		}
		else if (type === 'currency') {
			output = Number(output).toFixed(2);
		}

		// Round the decimals if there are any
		if (output > 0 && output % 1 > 0) {
			output = Number(output).toFixed(2);
		}

		// Trim the decimals off large numbers
		if (output > 1000) {
			output = Math.round(output);
		}

		var nStr = output + '';
		var x = nStr.split('.');
		var x1 = x[0];
		var x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ',' + '$2');
		}
		output = x1 + x2;

		return output;
	};

	fn.prototype.unFormat = function(type, value) {
		var output = this.cleanValue(value);

		if (type === 'percent100') {
			output /= 100;
		}
		else if (type === 'magnitudemil') {
			output *= 1000000;
		}

		return output;
	};

	fn.prototype.cleanValue = function(value) {
		var output = value || 0;

		if (typeof output === 'string') {
			var clean = output.replace(/[^0-9-.]/g, '').replace(/,/g, '');
			output = parseFloat(clean, 10);
		}

		return Number(output);
	};

});


// ----------------------------------------------------------------------------
// Fixed Value Component
// ----------------------------------------------------------------------------

mod.components.define("FixedValue", "Base", function (fn) {

    fn.prototype.init = function (params) {
        this.base("init", params);
        this.value = this.el.attr('data-value');
    }

    fn.prototype.getValue = function () {
        return this.value;
    };

});

// ----------------------------------------------------------------------------
// Button
// ----------------------------------------------------------------------------

mod.components.define("Button", "Base", function(fn) {

	fn.prototype.events = {
		"button[data-action=filter-button]": {
			"click": function (e, $el) {
			    
				if ($el.parents("div#tickerlist_ticker_filter").length > 0) {
					var textarea = $el.parents("[data-safename='WSODIssueID']").find('textarea');
					textarea.trigger('filter');
				} else {
					mod.observer.trigger("screener - screen", { resetPaging: true });
				}
			}
		}
	};

});

// ----------------------------------------------------------------------------
// TextBox
// ----------------------------------------------------------------------------

mod.components.define("TextBox", "Base", function(fn) {

	fn.prototype.getValue = function() {
		return this.$el.find("input[type=text]").val();
	};

	fn.prototype.setValue = function (value, fromSaved) {
		$input = this.$el.find("input[type=text]");
		value = $input.getAttribute("data-saved") || value;
		$input.val(value);

		if (fromSaved) {
			$input.setAttribute("data-saved", value);
		}
	};

});

mod.components.define("Text", "Base", function(fn) {

});

mod.components.define("WatchlistSelect", "Base", function (fn) {

	fn.prototype.events = {
		"a": {
			"click": function (e, $el) {
				var textarea = $el.parents("[data-safename='WSODIssueID']").find('textarea');
				textarea.val($el.data("symbol-list"));
				textarea.trigger('filter');
			}
		}
	};

});

// ----------------------------------------------------------------------------
// TextArea
// ----------------------------------------------------------------------------

mod.components.define("TextArea", "Base", function (fn) {

	fn.prototype.getValue = function () {
		return this.$el.find("textarea").val();
	};

	fn.prototype.setValue = function (value) {
		this.$el.find("textarea").val(value);
	};


	fn.prototype.getIdentifier = fn.prototype.getValue;

	fn.prototype.events = {
		"textarea": {
			"filter": function (e, $el) {

				var container = $el.parent('div.screener-component-textarea');
				var error_msgContainer = container.parents(".TickerListFilter").find('#tickerlist_error_msg');
				error_msgContainer.hide();
				if (this.getIdentifier() != "") {
					$el.parents('div.screener-content').addClass("loading");
					$.ajax({
						url: "GetWsodIssueByTicker",
						type: "post",
						dataType: "json",
						data: {
							tickersliststr: this.getIdentifier()
						},
						context: this,
						success: function(results) {
							if (results) {
								var error_msg = "";
								container.attr("data-wsodissue", results.wsodIssue);
								mod.observer.trigger("screener - screen", { resetPaging: true });
								if (results.invalidTickers != "") {
									error_msgContainer.attr("invalid-symbol", results.invalidTickers);
									error_msg += "<span> The ticker " + results.invalidTickers + " is not valid and could not be added.</span>";
								}
								if (results.duplicateTickers != "") {
									error_msgContainer.attr("duplicate-symbol", results.duplicateTickers);
									error_msg += "<span> The ticker " + results.duplicateTickers + " is  already in screener.</span>";
								}
								if (error_msg != "") {
									error_msgContainer.html(error_msg);
									error_msgContainer.show();
								}
							}
						},
						error: function error() {
							alert("There was an error with ticker list filter.");
						}
					});
				} else {
					error_msgContainer.html("<span>Please add a ticker(s) before filtering</span>");
					error_msgContainer.show();
				}
			}
		}
	};

});

// ----------------------------------------------------------------------------
// TextRange
// ----------------------------------------------------------------------------

mod.components.define("TextRange", "Base", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);

		var minValueRaw = this.el.attr('data-min');
		var maxValueRaw = this.el.attr('data-max');

		if (minValueRaw !== undefined) {
			this.minValue = parseFloat(this.el.attr('data-min'), 10);
		}
		else {
			this.minValue = 0;
		}

		if (maxValueRaw !== undefined) {
			this.maxValue = parseFloat(this.el.attr('data-max'), 10);
		}
		else {
			this.maxValue = 0;
		}

		this.updateLabels(this.minValue, this.maxValue);
	};

	fn.prototype.updateLabels = function(min, max) {
		this.el.find('.detail-min .detail-value').html(this.format(this.formatType, min));
		this.el.find('.detail-max .detail-value').html(this.format(this.formatType, max));
	};

	fn.prototype.getValue = function() {
		var $textBoxes = this.$el.find("input[type=text]");
		var fromValue = $.trim($textBoxes[0].value);
		var toValue = $.trim($textBoxes[1].value);
		var gtValue = this.cleanValue(fromValue);
		var ltValue = this.cleanValue(toValue);

		// Default the min/max values if the user entered nothing or gibberish
		if (fromValue === '' || isNaN(fromValue) || toValue === '' || isNaN(toValue)) {
			if (fromValue === '' || isNaN(fromValue)) {
				gtValue = this.minValue;
			}

			if (toValue === '' || isNaN(toValue)) {
				ltValue = this.maxValue;
			}
		}
		else {
			var tmpMin = gtValue;
			var tmpMax = ltValue;

			gtValue = Math.min(tmpMin, tmpMax);
			ltValue = Math.max(tmpMin, tmpMax);
		}

		// Make sure the to/from values are within the range
		gtValue = Math.max(this.minValue, gtValue);
		ltValue = Math.min(this.maxValue, ltValue);

		this.setValue([gtValue, ltValue]);

		return [
			this.getClause("GreaterThanOrEqualTo", gtValue),
			this.getClause("LessThanOrEqualTo", ltValue)
		];
	};

	fn.prototype.setValue = function (values, fromSaved) {

		if (values && values.length) {
			var $textBoxes = this.$el.find("input[type=text]");
			
			if (fromSaved) {
				$textBoxes[0].setAttribute("data-saved", values[0]);
				$textBoxes[1].setAttribute("data-saved", values[1]);
			}

			$textBoxes[0].value = $textBoxes[0].getAttribute("data-saved") || values[0];
			$textBoxes[1].value = $textBoxes[1].getAttribute("data-saved") || values[1];
		}
	};

	fn.prototype.receiveAsync = function(res) {
		this.minValue = res.min;
		this.maxValue = res.max;

		this.setValue([this.minValue, this.maxValue]);
		this.updateLabels(this.minValue, this.maxValue);
	};

	fn.prototype.events = {
		"button": {
			"click": function(e, $el) {
				// Trigger a new screen call
				mod.observer.trigger("screener - screen", { resetPaging: true });
			}
		}
	};
});

// ----------------------------------------------------------------------------
// Single Select
// ----------------------------------------------------------------------------

mod.components.define("SingleSelect", "Base", function(fn) {

	fn.prototype.getValue = function () {
		var val = this.$el.find("select").val();

		if (!val) {
			val = $(this.$el.find("option").first()).val()
		}

		return val;
	};

	fn.prototype.setValue = function(value) {
		this.$el.find("select").val(value);
	};

	fn.prototype.getIdentifier = fn.prototype.getValue;

	fn.prototype.events = {
		"select": {
			"change": function(e, $el) {
				var select = e.currentTarget;
				var $option = $(select.options[select.selectedIndex]);

				// Look for actions to handle
				var actionsJson = $option.attr("data-actions");

				try {
					if (actionsJson) {
						var actions = JSON.parse(actionsJson);
						this.parseActions(actions);

						if (!actions.Reload) {
							mod.observer.trigger("screener - screen", { resetPaging: true });
						}
					}
					else {
						mod.observer.trigger("screener - screen", { resetPaging: true });
					}
				}
				catch (e) { }
			}
		}
	};

});

// ----------------------------------------------------------------------------
// Single Select (Date)
// ----------------------------------------------------------------------------

mod.components.define("SingleSelectDate", "SingleSelect", function(fn) {

	function addMinutes(date, minutes) {
		return new Date(date.getTime() + minutes * 60000);
	}

	fn.prototype.getValue = function() {
		var days = this.$el.find("select").val();
		var minutes = days * 60 * 24; // TODO: subtract minutes in today so we look at 12:00am
		var now = new Date();
		var then = addMinutes(now, minutes);

		return then;
	};

	fn.prototype.getIdentifier = function() {
		return this.$el.find("select").val();
	};

});

// ----------------------------------------------------------------------------
// Multi Select
// ----------------------------------------------------------------------------

mod.components.define("MultiSelect", "Base", function(fn) {

	// Node that holds all the "selected" options
	fn.prototype.$optionTracker = null;

	fn.prototype.init = function(params) {
		// Cache
		this.$optionTracker = this.$el.find("div.multiselectOptionTracker");
	};

	fn.prototype.getValue = function() {
		var values = [];
		var $options = this.$optionTracker.children();

		if ($options.length) {
			for (var i = 0; i < $options.length; i++) {
				var $option = $options.eq(i);
				var value = $option.attr("data-value");
				values.push(value);
			}
		}

		return values;
	};

	fn.prototype.setValue = function(values) {
		var $valSelect = this.el.find('select');

		// Set the values
		for (var i = 0; i < values.length; i++) {
			$valSelect.val(values[i]).change();
		}

		// Move the index back to the first value
		$valSelect.val('%');
	};

	// Add the value to our list of "selected" options
	fn.prototype.trackSelectedValue = function(label, value) {
		var $options = this.$optionTracker.children();
		var isAlreadyAdded = false;

		// See if we've already added this value
		for (var i = 0; i < $options.length; i++) {
			var $option = $options.eq(i);

			if ($option.attr("data-value") == value) {
				isAlreadyAdded = true;
				break;
			}
		}

		if (!isAlreadyAdded) {
			var $newOption = this.renderTrackedOption(label, value);
			this.$optionTracker.append($newOption);
		}
	};

	// Create the DOM node for the tracked option
	fn.prototype.renderTrackedOption = function(label, value) {
		return $('<a href="javascript:;" class="btn btn-mini" data-value="' + value + '"></a>').append(
			$("<span>" + label + "</span>"),
			$('<i class="icon-remove"></i>')
		);
	};

	fn.prototype.events = {
		"select": {
			"change": function(e, $el) {
				var select = e.currentTarget;
				var $option = $(select.options[select.selectedIndex]);

				// Make sure it's not a dummy option
				if (!$option.attr("data-placeholder")) {
					this.trackSelectedValue($option.text(), $option.val());
				}

				// Reset the drop down
				select.selectedIndex = 0;

				mod.observer.trigger("screener - screen", { resetPaging: true });
			}
		},
		".multiselectOptionTracker a": {
			"click": function(e, $el) {
				$el.remove();

				mod.observer.trigger("screener - screen", { resetPaging: true });
			}
		}
	};

});

// ----------------------------------------------------------------------------
// Button Group
// ----------------------------------------------------------------------------

mod.components.define("ButtonGroup", "Base", function(fn) {

	// Grab all the active buttons
	fn.prototype.getValue = function() {
		var values = [];
		var $buttons = this.$el.find("button.active");

		if ($buttons.length) {
			for (var i = 0; i < $buttons.length; i++) {
				var $button = $buttons.eq(i);
				var value = $button.attr("data-value");

				values.push(value);
			}
		}
		else {
			values.push(this.valueNone);
		}

		return values;
	};

	fn.prototype.setValue = function(values) {
		for (var i = 0; i < values.length; i++) {
			this.el.find('button[data-value="' + values[i] + '"]').trigger('click');
		}
	};

	fn.prototype.events = {
		"button": {
			"click": function(e, $el) {
				// Kick the handler into the event queue so the normal button behavior will run first
				// The correct button will be selected by the time we build inputs for the screener call
				setTimeout(function() {
					mod.observer.trigger("screener - screen", { resetPaging: true });
				}, 0);
			}
		}
	};

});

// ----------------------------------------------------------------------------
// Base Slider
// ----------------------------------------------------------------------------

mod.components.define("BaseSlider", "Base", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.$slider = null;
		this.minValue = null;
		this.maxValue = null;

		// Cache
		this.$slider = this.$el.find("div.slider");

		// Get Min Value off the container
		if (this.$el.attr("data-slider-min")) {
			this.minValue = parseFloat(this.$el.attr("data-slider-min"), 10);
		}

		// Get Max Value off the container
		if (this.$el.attr("data-slider-max")) {
			this.maxValue = parseFloat(this.$el.attr("data-slider-max"), 10);
		}
	};

	fn.prototype.handleSliderStop = function(e, ui) {
		mod.observer.trigger("screener - screen", { resetPaging: true });
	};

	fn.prototype.getValue = function() {
		var clauses = [];
		var minOperator = "GreaterThanOrEqualTo";
		var maxOperator = "LessThanOrEqualTo";
		var values = this.$slider.slider("values");

		if (values) {
			var minValue = values[0];
			var maxValue = values[1];

			clauses = [
				this.getClause(minOperator, minValue),
				this.getClause(maxOperator, maxValue)
			];
		}

		return clauses;
	};

	fn.prototype.setValue = function(values) {
		values = [].concat(values);

		if (!values.length || !values[0]) {
			values[0] = this.minValue;
		}

		if (values.length < 2 || !values[1]) {
			values[1] = this.maxValue;
		}

		this.$slider.slider("values", values);
	};

});

// ----------------------------------------------------------------------------
// Bucket Slider
// ----------------------------------------------------------------------------

mod.components.define("BucketSlider", "BaseSlider", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.$rangeLabel = null;
		this.stepValue = null;

		// Get values off our container
		this.stepValue = parseInt(this.$el.attr("data-slider-step"), 10);

		this.initSlider(this.minValue, this.maxValue, this.stepValue);
	};

	fn.prototype.initSlider = function(min, max, step) {
		// Setup the slider
		this.$slider.slider({
			range: true,
			min: min,
			max: max,
			values: [min, max],
			step: step,
			slide: $.proxy(this.updateRangeLabel, this),
			stop: $.proxy(this.handleSliderStop, this),
			change: $.proxy(this.updateRangeLabel, this)
		});

		// Inject a new DOM node into the range
		this.$rangeLabel = $("<span class='slider-range-label' />");
		this.$slider.find(".ui-slider-range").append(this.$rangeLabel);

		// Set up the initial label
		this.updateRangeLabel();
	};

	fn.prototype.updateRangeLabel = function(e, ui) {
		var values = (ui) ? ui.values : this.$slider.slider("values");
		var formattedMinValue = this.format("percent", values[0]);
		var formattedMaxValue = this.format("percent", values[1]);

		// Update the label
		this.$rangeLabel.text(formattedMinValue + " - " + formattedMaxValue);
	};

});

// ----------------------------------------------------------------------------
// Histogram Slider
// ----------------------------------------------------------------------------

mod.components.define("HistogramSlider", "BaseSlider", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.$errorWrapper = this.$el.parent("div.component-content").siblings("div.component-error");
		this.$contentWrapper = this.$el.parent("div.component-content");

		this.fromInput = null;
		this.toInput = null;
		this.formatType = null;
		this.minOperator = "GreaterThanOrEqualTo";
		this.maxOperator = "LessThanOrEqualTo";

		// Cache
		var $inputs = this.$el.find("div.label-group input");
		this.fromInput = $inputs[0];
		this.toInput = $inputs[1];

		// Pull our format type off the container
		this.formatType = this.$el.attr("data-formatType") || "number";

		this.initSlider(this.minValue, this.maxValue);

		// Map the values to pixels
		var encodedRangeList = this.$el.attr("data-rangelist").replace('B64ENC', '');
		var jsonRangeList = $.fromBase64(encodedRangeList);
		var rangeList = [].concat(JSON.parse(jsonRangeList));
		this.setRangeList(rangeList);
	};

	fn.prototype.setRangeList = function(range) {
		this.pixelMap = this.mapValuesToPixelLine(range);
		this.pixelMap.push(this.maxValue);
		this.pixelRatio = (this.maxValue - this.minValue) / this.pixelMap.length; // How much each pixel is "worth"
	};

	fn.prototype.initSlider = function(min, max) {
		// Setup the slider
		this.$slider.slider({
			range: true,
			min: min,
			max: max,
			//step: (max - min) / 100,
			step: 0.01,
			values: [min, max],
			slide: $.proxy(this.handleSliderSlide, this),
			stop: $.proxy(this.handleSliderStop, this)
		});

		// Setup the inputs
		this.fromInput.value = this.format(this.formatType, min);
		this.fromInput.setAttribute('data-raw', min);
		this.toInput.value = this.format(this.formatType, max);
		this.toInput.setAttribute('data-raw', max);
	};

	fn.prototype.setValueFromSlider = function(e, ui) {
		var input = (ui.value == ui.values[0])
			? this.fromInput
			: this.toInput;

		// Figure out where the handle is relative to the left hand side
		var handleXPosition = parseFloat($(ui.handle).css('left'), 10);

		// See if we should round up or down
		if (handleXPosition < this.pixelMap.length / 2) {
			handleXPosition = Math.floor(handleXPosition);
		}
		else {
			handleXPosition = Math.ceil(handleXPosition);
		}

		// Don't the handle fall outside the range
		handleXPosition = Math.min(handleXPosition, this.pixelMap.length + 1);
		handleXPosition = Math.max(1, handleXPosition);

		// Pull the actual value from out pixel map
		var value = this.pixelMap[handleXPosition - 1];

		// Update the input box
		input.setAttribute('data-raw', value);
		input.value = this.format(this.formatType, value);
	};

	fn.prototype.handleSliderSlide = function(e, ui) {
		this.setValueFromSlider(e, ui);
	};

	fn.prototype.handleSliderStop = function(e, ui) {
		this.setValueFromSlider(e, ui);
		mod.observer.trigger("screener - screen", { resetPaging: true });
	};

	fn.prototype.getValue = function() {
		var fromValue = this.getValueFromInput(this.fromInput);
		var toValue = this.getValueFromInput(this.toInput);

		// Figure out which is bigger
		var minValue = Math.min(fromValue, toValue);
		var maxValue = Math.max(fromValue, toValue);

		// Make sure the min and max aren't out of bounds
		minValue = Math.min(minValue, this.maxValue);
		maxValue = Math.max(maxValue, this.minValue);

		// Make sure the slider is updated
		this.setValue([minValue, maxValue]);

		return [
			this.getClause(this.minOperator, minValue),
			this.getClause(this.maxOperator, maxValue)
		];
	};

	fn.prototype.getValueFromInput = function(input) {
		var value = parseFloat(input.getAttribute('data-raw')); // The original raw value
		var valueFormat = this.format(this.formatType, value);	// The raw value formatted
		var valueDisplay = input.value;	// The formatted value from the input

		// If the displayed value doesn't match the formatted value then the user must have changed it
		if (valueFormat !== valueDisplay) {
			value = this.unFormat(this.formatType, valueDisplay);
		}

		return value;
	};

	fn.prototype.receiveAsync = function(response) {
		if (response.status === 1) {
			this.$errorWrapper.hide();
			this.$contentWrapper.show();

			// Update our values
			this.minValue = response.min;
			this.maxValue = response.max;

			this.setRangeList([].concat(response.rangelist));

			// Restart the slider with the new values
			this.initSlider(this.minValue, this.maxValue);

			// Update the chart url
			if (response.url) {
				this.$el.find("img").attr("src", response.url);
			}

			this.setValue([this.minValue, this.maxValue]);
		}
		else {
			this.$errorWrapper.show();
			this.$contentWrapper.hide();
		}
	};

	fn.prototype.setValue = function(values, fromSaved) {
		var translatedValues = [0, 0];

		if (values) {
			// Set "min" value
			if (values.length) {
				var minValue = Math.max(this.minValue, values[0]);
				minValue = this.fromInput.getAttribute("data-saved") || minValue;

				// Figure out what the slider thinks the value should be
				translatedValues[0] = this.translateActualToPerceivedValue(minValue);

				if (translatedValues[0] === this.minValue) {
					minValue = this.minValue;
				}
				else if (minValue === 0) {
					// Show SOMETHING if the minValue is 0
					// This often happens when the translated value is 0.054321 and minValue is 0
					minValue = translatedValues[0];
				}

				this.fromInput.value = this.format(this.formatType, minValue);
				this.fromInput.setAttribute('data-raw', minValue);
				if (fromSaved) {
					this.fromInput.setAttribute('data-saved', minValue);
				}
			}

			// Set "max" value
			if (values.length > 1) {
				var maxValue = Math.min(this.maxValue, values[1]);

				maxValue = this.toInput.getAttribute("data-saved") || maxValue;

				// Figure out what the slider thinks the value should be
				translatedValues[1] = this.translateActualToPerceivedValue(maxValue);

				if (translatedValues[1] === this.maxValue) {
					maxValue = this.maxValue;
				}
				else if (isNaN(maxValue) || maxValue === undefined) {
					maxValue = this.maxValue;
				}

				this.toInput.value = this.format(this.formatType, maxValue);
				this.toInput.setAttribute('data-raw', maxValue);
				if (fromSaved) {
					this.toInput.setAttribute('data-saved', maxValue);
				}
			}
		}

		this.$slider.slider("values", translatedValues);
	};

	fn.prototype.translateActualToPerceivedValue = function(actual) {
		// Figure out what the slider thinks the value should be
		var xPosition = this.getPixelFromValue(actual);

		// Do a little smart snapping at both ends
		//if (xPosition < 3) {
		//	xPosition = 0;
		//}
		//else if (this.pixelMap.length - xPosition < 3) {
		//	xPosition = this.pixelMap.length - 1;
		//}

		// Add 1 if we're on the upper end of the range
		if (xPosition > this.pixelMap.length / 2) {
			xPosition += 1;
		}

		var sliderValue;

		if (xPosition === this.pixelMap.length) {
			sliderValue = this.maxValue;
		}
		else if (xPosition === 0) {
			sliderValue = this.minValue;
		}
		else {
			sliderValue = (xPosition * this.pixelRatio) + this.minValue;
			sliderValue = Math.max(this.minValue, sliderValue);
			sliderValue = Math.min(this.maxValue, sliderValue);
		}

		return sliderValue;
	};

	fn.prototype.getPixelFromValue = function(value) {
		var index = 0;

		// Exit early if we're returning max
		if (value >= this.maxValue) {
			index = this.pixelMap.length - 1;
		}
		else if (value <= this.minValue) {
			index = 0;
		}
		else {
			for (var i = 0, len = this.pixelMap.length; i < len; i++) {
				if (this.pixelMap[i] === value) {
					index = i;
					break;
				}
				else if (this.pixelMap[i] > value) {
					var diffBefore = value - this.pixelMap[i - 1];
					var diffAfter = this.pixelMap[i] - value;

					// See which index is closer to the number
					if (diffBefore < diffAfter) {
						index = i - 1;
					}
					else {
						index = i;
					}

					break;
				}
			}
		}

		return index;
	};

	fn.prototype.mapValuesToPixelLine = function(range) {
		var values = [];

		// Go over every item in the range
		for (var i = 0, len = range.length; i < len; i++) {
			var width = range[i].Width;

			// See if we skipped any x positions b/w bars
			if (i != 0) {
				width += range[i].X - range[i - 1].X - width;
			}

			var step = (range[i].Max - range[i].Min) / width;

			// Add an index for each pixel
			for (var x = 0; x < width; x++) {
				values.push(range[i].Min + (x * step));
			}
		}

		return values;
	};

});

// ----------------------------------------------------------------------------
// Date Range
// ----------------------------------------------------------------------------

mod.components.define("DateRangePicker", "Base", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.$el.find("input.datepicker").datepicker();
	};

	fn.prototype.getValue = function() {
		var $inputs = this.$el.find("input.datepicker");

		var fromValue = $.trim($inputs.eq(0).val());
		var toValue = $.trim($inputs.eq(1).val());

		var minValue = this.getOADateFromString(fromValue);
		var maxValue = this.getOADateFromString(toValue);

		if (fromValue === '' || toValue === '') {
			fromValue = fromValue || this.valueAll;
			toValue = toValue || this.valueAll;
		}
		else {
			var tmpMin = minValue;
			var tmpMax = maxValue;

			minValue = Math.min(tmpMin, tmpMax);
			maxValue = Math.max(tmpMin, tmpMax);
		}

		this.setValue([minValue, maxValue]);

		return [
			this.getClause("GreaterThanOrEqualTo", minValue),
			this.getClause("LessThanOrEqualTo", maxValue)
		];
	};

	fn.prototype.setValue = function(values) {
		var $inputs = this.$el.find("input.datepicker");

		if (values && values.length) {
			var $dateInputs = this.$el.find("input.datepicker");
			var format = 'MM/DD/YY';

			// Set "Start date"
			if (values[0] && values[0] !== this.valueAll) {
				var startDate = moment.fromOADate(values[0]).format(format);
				$dateInputs.eq(0).datepicker('setDate', startDate);
			}

			// Set "End date"
			if (values.length > 1 && values[1] && values[1] !== this.valueAll) {
				var endDate = moment.fromOADate(values[1]).format(format);
				$dateInputs.eq(1).datepicker('setDate', endDate);
			}
		}
	};

	// Expects "mm/dd/yyyy" format
	fn.prototype.getOADateFromString = function(dateString) {
		var parts = dateString.split("/");

		// Create a sane structure for the values
		var components = {
			day: parseInt(parts[1]),
			month: parseInt(parts[0]),
			year: parseInt(parts[2])
		};

		// Make a new date obj
		var date = new Date(components.year, components.month - 1, components.day);

		// Convert the date into universal ms date
		var msDate = (date - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);

		return msDate;
	};

});

// ----------------------------------------------------------------------------
// ShowAvailableToggle On/Off Toggle
// ----------------------------------------------------------------------------

mod.components.define("ShowAvailableToggle", "Base", function (fn) {

});
